// hooks/useDeleteTable.ts
import { useCallback, useContext } from 'react';
import { useApp } from '@realm/react';
import { UserContext } from '../../contexts/UserContext';
import { ObjectId } from 'bson';

export const useDeleteTable = () => {
    const app = useApp();
    const { user } = useContext(UserContext);

    const deleteTable = useCallback(async (tableId: string) => {
        if (!user || !app.currentUser) {
            console.error("User is not authenticated");
            return;
        }

        const siteId = app.currentUser.customData.currentSite.toString();

        try {
            const mongo = user.mongoClient('mongodb-atlas');
            const tableCollection = mongo.db('pos').collection('Table');
            const filter = { _id: {"$oid" :tableId}, siteId: siteId };

            const result = await tableCollection.deleteOne(filter);
            console.log("Delete result:", result);
            return result;
        } catch (error) {
            console.error("Failed to delete table:", error);
            throw error;
        }
    }, [user, app]);

    return { deleteTable };
};
